import { Button, Grid, InputAdornment, InputLabel, List, ListItem, ListItemText, TextField, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createTechnician, updateTechnician, createTechnicianFailed } from "../../../redux/manageLabourer/manageLabourerActions";
import StyledCheckbox from "../../common/styledCheckbox";
import CancelIcon from "../../common/icons/cancelIcon";
import Modal from "../../common/modal/modal";
import { getLocalizedNameWithIntl } from "../../../globals/langHelpers";
import { useIntl, defineMessages } from "react-intl";

const useStyles = makeStyles({
    root: {
        padding: "10px 5px 0px 0px",
        "& .MuiFormLabel-root.Mui-error, .MuiFormHelperText-root.Mui-error, .MuiInput-underline.Mui-error:after": {
            color: "#BD2025",
            borderBottomColor: "#BD2025",
        },
        "& .makeStyles-formCss-54": {
            padding: 10,
        },
        "& .MuiInputLabel-formControl": {
            fontSize: "14px",
            fontFamily: "Arial",
        },
        "& .MuiInputBase-input": {
            fontSize: "14px",
        },
        "& .MuiFormLabel-asterisk": {
            color: "red",
            paddingLeft: "4px,",
            float: "left",
        },
    },
    contractList: {
        paddingTop: "10px",
        "& .MuiListItem-root": {
            paddingTop: 0,
            paddingBottom: 0,
        },
        "& .MuiTypography-body1": {
            fontSize: 12,
            color: "#555555",
            fontFamily: "Arial",
        },
        "& .MuiList-padding": {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
    btn: {
        bottom: "0px",
        display: "flex",
        padding: 25,
        justifyContent: "flex-end",
    },
    autoCompleteOption: {
        fontSize: 12,
    },
    multipleSkills: {
        "& .MuiChip-root": {
            background: "rgba(0, 84, 154, 0.1)",
            border: "1px solid #00549A",
            borderRadius: "4px",
        },
        "& .MuiChip-deleteIcon": {
            color: "#00549A",
        },
        "& .MuiSvgIcon-root": {
            color: "#00549A",
        },
        "& .MuiFormLabel-root.Mui-focused": {
            color: "#00549A",
        },
        "& .MuiInput-underline:after": {
            borderBottom: "2px solid #00549A",
        },
        "& .MuiCheckbox-colorSecondary.Mui-checked": {
            color: "#00549A",
        },
        "& .MuiChip-label": {
            fontSize: "12px",
            color: "#00549A",
        },
    },
});
const labels = defineMessages({
    cancel: {
        id: "admin.work-order-details.cancel-changes",
        defaultMessage: "Cancel",
        description: "Admin work order cancel changes button",
    },
    close: {
        id: "admin.work-order-details.close",
        defaultMessage: "Close",
        description: "Admin work order close text",
    },
    error: {
        id: "admin.work-order-details.error",
        defaultMessage: "Error",
        description: "Admin work order error",
    },
    open: {
        id: "admin.work-order-details.open",
        defaultMessage: "Open",
        description: "Admin work order open",
    },
    noOptions: {
        id: "admin.work-order-details.no-options",
        defaultMessage: "No options",
        description: "Admin work order no options",
    },
    skills: {
        id: "cmis-lab-details-label.skills",
        defaultMessage: "Skills",
        description: "Skills label",
    },
    addMore: {
        id: "manage-labourers-filter.add-more",
        defaultMessage: "Add more",
        description: "Add more placeholder",
    },
    contractNames: {
        id: "cmis-lab-details-label.contract-name",
        defaultMessage: "Contract Name(s)",
        description: "contract names label",
    },
    contactNumberError: {
        id: "manage-labourers-error.contact-number-digits-error",
        defaultMessage: "Contact number must be 10 digits",
        description: "Contact number must be 10 digits error",
    },
    emailError: {
        id: "manage-labourers-error.email-valid-error",
        defaultMessage: "Email must be a valid address",
        description: "Email must be a valid address error",
    },
    usernameError: {
        id: "manage-labourers-error.username-error",
        defaultMessage: "Username is a required field",
        description: "Username is a required field error",
    },
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            createTechnician,
            updateTechnician,
            createTechnicianFailed,
        },
        dispatch,
    );

const mapStateToProps = (state) => {
    return {
        error: state.errors,
    };
};

function NumberFormatter(props) {
    return (
        <NumberFormat
            {...props}
            getInputRef={props.inputref}
            format={"###-###-####"}
            onValueChange={(values) => {
                props.onChange({ target: { value: values.value, length: values.value.length } });
            }}
        />
    );
}
/*
props.contracts
props.skills
props.technician
props.fields
*/
function LabourerEditForm(props) {
    const classes = useStyles();
    const intl = useIntl();
    const [formFields, setFormFields] = useState([]);
    const [errorFields, setErrorFields] = useState({});
    const [checks, setChecks] = useState({ contracts: ([] = []), skills: ([] = []), uncheckedContracts: ([] = []), uncheckedSkills: ([] = []) });
    const [technicianSkills, setTechnicianSkills] = useState([]);
    const [phoneValue, setPhoneValue] = useState({ phone: "" });
    const emailValidatorRegEx = RegExp(/^([\w.%+-]+)@([\w-]+\.)+([a-z]{2,})$/i);

    /* To handel contract Check */
    var handlecontractcheck = (value) => {
        let checkedContracts = checks.contracts;
        let checkedSkills = checks.skills;
        let uncheckedContracts = checks.uncheckedContracts ? checks.uncheckedContracts : [];
        let uncheckedSkills = checks.uncheckedSkills ? checks.uncheckedSkills : [];
        if (props.technician && props.technician.contracts.filter((c) => c.contractNumber === value).length > 0) {
            uncheckedContracts.includes(value) ? uncheckedContracts.splice(uncheckedContracts.indexOf(value), 1) : uncheckedContracts.push(value);
        }
        checkedContracts.includes(value)
            ? checkedContracts.splice(checkedContracts.indexOf(value), 1)
            : props.contracts.filter((c) => c.contractNumber === value).map((c) => checkedContracts.push(c.contractNumber));
        setChecks({ contracts: checkedContracts, skills: checkedSkills, uncheckedContracts: uncheckedContracts, uncheckedSkills: uncheckedSkills });
    };
    /* To handel skill Check */
    const handleSkillCheck = (value) => {
        let checkedContracts = checks.contracts;
        let checkedSkills = checks.skills;
        let uncheckedContracts = checks.uncheckedContracts ? checks.uncheckedContracts : [];
        let uncheckedSkills = checks.uncheckedSkills ? checks.uncheckedSkills : [];
        checkedSkills.includes(parseInt(value)) ? checkedSkills.splice(checkedSkills.indexOf(value), 1) : checkedSkills.push(parseInt(value));
        setChecks({ contracts: checkedContracts, skills: checkedSkills, uncheckedContracts: uncheckedContracts, uncheckedSkills: uncheckedSkills });
    };

    /* Handling Save Techinician */
    var handelSaveChanges = (event) => {
        let skillAdded = [];
        let skillDeleted = [];
        let propsSkills = [];
        let selectedSkills = [];

        if (
            formFields.filter((field) => field.isError === true).length === 0 &&
            formFields.filter((field) => field.required === true && field.value === "").length === 0
        ) {
            if (props.technician && props.technician.skills.length > 0) {
                props.technician.skills.forEach((s) => propsSkills.push(s.id));
                technicianSkills.forEach((skill) => selectedSkills.push(skill.id));
                selectedSkills.forEach((skillToAdd) => {
                    if (!propsSkills.includes(skillToAdd)) skillAdded.push(skillToAdd);
                });
                propsSkills.forEach((skillToDelete) => {
                    if (!selectedSkills.includes(skillToDelete)) skillDeleted.push(skillToDelete);
                });
            } else {
                technicianSkills.forEach((skill) => {
                    if (!skillAdded.includes(skill.id)) skillAdded.push(skill.id);
                });
            }
            if (props.technician && props.technician.contracts.length > 0) {
                props.technician.contracts.forEach((c) => {
                    if (checks.contracts.includes(c.contractNumber)) checks.contracts.splice(checks.contracts.indexOf(c.contractNumber), 1);
                });
            }
            let obj = Object.create(null);
            formFields.forEach((field) => {
                if (field.key === "contracts" || field.key === "skills") {
                    let O = Object.create(null);
                    O["added"] = field.key === "contracts" ? checks.contracts : skillAdded;
                    O["deleted"] = field.key === "contracts" ? checks.uncheckedContracts : skillDeleted;
                    obj[field.key] = O;
                } else obj[field.key] = field.value;
            });
            if (props.technician && props.technician.id !== 0) {
                obj["id"] = props.technician.id;
                obj["relatedKeycloakUserId"] = props.technician.relatedKeycloakUserId;
                obj["pein"] = props.technician.pein;
                obj["vendorNumber"] = props.technician.vendorNumber;
                props.updateTechnician(obj);
            } else {
                props.createTechnician(obj);
            }
        }
    };

    useEffect(() => {
        if (props.error === "success") props.handelSave(true);
    }, [props.error]);

    /* Interactive Skill and Contract Checks */
    useEffect(() => {
        let fields = formFields;
        fields.filter((field) =>
            field.key === "contracts" ? (field.value = checks.contracts) : field.key === "skills" ? (field.value = checks.skills) : field.value,
        );
        setFormFields(fields);
    }, [checks.contracts, checks.skills]);

    /* Validation form fields */
    useEffect(() => {
        let fields = formFields;
        if (errorFields.length > 0) {
            errorFields.forEach((errField) => {
                formFields
                    .filter((formFiled) => formFiled.key === errField.key)
                    .map((f) => {
                        f.isError = errField.isError;
                        f.errorMessage = errField.errorMessage;
                        f.value = errField.value;
                    });
            });
        }
        setFormFields(fields);
    }, [errorFields]);

    /* Initial Effect to set Techinician and Fields */
    useEffect(() => {
        props.createTechnicianFailed("");
        let contracts = [];
        let skills = [];
        let techSkills = [];
        if (props.fields.length > 0) {
            props.fields.forEach((field) => {
                field.isError = false;
                field.errorMessage = "";
                if (field.key === "contracts") {
                    if (props.technician && props.technician.contracts.length > 0)
                        props.technician.contracts
                            .filter((c) => {
                                return c.contractNumber;
                            })
                            .map((cn) => contracts.push(cn.contractNumber));
                    field.value = contracts;
                } else if (field.key === "skills") {
                    if (props.technician && props.technician.skills.length > 0)
                        props.technician.skills.forEach((skill) => {
                            let obj = {};
                            obj = { id: skill.id, name_en: skill.name_en, name_fr: skill.name_fr };
                            techSkills.push(obj);
                            skills.push(skill.id);
                        });
                    field.value = skills;
                } else if (field.key === "phone") {
                    if (props.technician && props.technician.phone !== "") {
                        setPhoneValue({ phone: props.technician.phone });
                        field.value = typeof phoneValue.phone === "undefiend" ? "" : phoneValue.phone;
                    }
                } else field.value = typeof props.technician[field.key] === "undefined" ? "" : props.technician[field.key];
            });

            setChecks({ contracts: contracts, skills: skills });
            setTechnicianSkills(techSkills);
            setFormFields(props.fields);
        }
    }, [props.technician]);

    /* Phone Format change handler */
    const handleInput = (event, field) => {
        setPhoneValue({
            phone: event.target.value,
        });
        field.value = event.target.value;
        validateFormFields(field, event.target.length);
    };

    /* Text fields chagne handler */
    const handleChange = (event, field) => {
        field.value = event.target.value;
        if (field.required) validateFormFields(field, event.target.value);
        else setErrorFields(Array.of(field));
    };

    const clearInput = (event, field) => {
        let fields = [];
        formFields.forEach((f) => {
            if (f.key === field.key && field.key !== "phone") {
                f.value = "";
                f.isError = false;
                f.errorMessage = "";
            } else if (f.key === field.key && field.key === "phone") {
                setPhoneValue({
                    phone: "",
                });
                f.value = "";
                f.isError = false;
                f.errorMessage = "";
            }
            fields.push(f);
        });
        setFormFields(fields);
    };

    /* Validation for all Form Fields */
    const validateFormFields = (field, value) => {
        let errors = [];
        switch (field.type) {
            case "text":
                if (field.key === "email") {
                    field.isError = !emailValidatorRegEx.test(value);
                    field.errorMessage = field.isError ? intl.formatMessage(labels.emailError) + " " : "";
                } else {
                    field.isError = value.length < 1;
                    field.errorMessage = field.isError ? intl.formatMessage(labels.usernameError) : "";
                }
                break;
            case "phone":
                if (value) {
                    field.isError = Number(value) < 10;
                    field.errorMessage = field.isError ? intl.formatMessage(labels.contactNumberError) : "";
                }
                break;
            default:
                break;
        }
        if (field.isError) {
            errors.forEach((err, i) => {
                if (errors.key === field.key) errors.splice(i, 1);
            });
            errors.push(field);
        }
        setErrorFields(errors);
    };

    return (
        <form autoComplete="off" className={classes.root}>
            <Grid container justify="center" spacing={1}>
                {formFields?.map((field, index) => {
                    return (
                        <Grid item xs={10} key={index}>
                            {(() => {
                                switch (field.type) {
                                    case "text":
                                        return (
                                            <TextField
                                                requried={field.required}
                                                size="small"
                                                label={intl.formatMessage(field.label)}
                                                fullWidth
                                                type="text"
                                                key={field.key}
                                                disabled={field.key === "userName" && props.technician !== ""}
                                                onChange={(event) => handleChange(event, field)}
                                                onBlur={(event) => handleChange(event, field)}
                                                error={Boolean(field.isError)}
                                                helperText={field.errorMessage}
                                                value={field.value}
                                                InputLabelProps={{ required: field.required }}
                                                InputProps={{
                                                    endAdornment: formFields[index].value !== "" &&
                                                        field.key !== "userName" &&
                                                        props.technician !== "" && (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={(event) => clearInput(event, formFields[index])}>
                                                                    <CancelIcon title="Clear Input" />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                }}
                                            />
                                        );
                                    case "textarea":
                                        return (
                                            <TextField
                                                size="small"
                                                label={intl.formatMessage(field.label)}
                                                fullWidth
                                                type="text"
                                                key={field.key + "" + field.Name}
                                                onChange={(event) => handleChange(event, field)}
                                                multiline
                                                rows={5}
                                                value={field.value}
                                                InputProps={{
                                                    endAdornment: formFields[index].value !== "" && (
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={(event) => clearInput(event, formFields[index])}>
                                                                <CancelIcon title="Clear Input" />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        );
                                    case "phone":
                                        return (
                                            <TextField
                                                size="small"
                                                label={intl.formatMessage(field.label)}
                                                fullWidth
                                                type="text"
                                                key={field.key}
                                                name={"phone"}
                                                error={Boolean(field.isError)}
                                                helperText={field.errorMessage}
                                                onBlur={(event) => handleInput(event, field)}
                                                onChange={(event) => handleInput(event, field)}
                                                value={phoneValue.phone}
                                                InputLabelProps={{ shrink: phoneValue.phone !== "" }}
                                                InputProps={{
                                                    inputComponent: NumberFormatter,
                                                    endAdornment: phoneValue.phone !== "" && (
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={(event) => clearInput(event, field)}>
                                                                <CancelIcon title="Clear Input" />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        );

                                    case "contractCheckList":
                                        return (
                                            <div className={classes.contractList}>
                                                <InputLabel shrink key={field.label}>
                                                    {intl.formatMessage(labels.contractNames)}
                                                </InputLabel>
                                                <List>
                                                    {props.contracts.map((contract, index) => {
                                                        return (
                                                            <ListItem key={contract.contractNumber + index}>
                                                                <StyledCheckbox
                                                                    value={contract.contractNumber}
                                                                    checked={field.value.includes(contract.contractNumber)}
                                                                    handlecheck={handlecontractcheck}
                                                                />
                                                                <ListItemText
                                                                    primary={contract.description}
                                                                    classes={{ primary: classes.listItemText }}
                                                                />
                                                            </ListItem>
                                                        );
                                                    })}
                                                </List>
                                            </div>
                                        );
                                    case "skillCheckList":
                                        return (
                                            <Autocomplete
                                                multiple
                                                limitTags={1}
                                                id={field.id}
                                                size="small"
                                                options={props.skills}
                                                disableCloseOnSelect
                                                value={technicianSkills}
                                                onChange={(option, value) => setTechnicianSkills(value)}
                                                closeText={intl.formatMessage(labels.close)}
                                                openText={intl.formatMessage(labels.open)}
                                                noOptionsText={intl.formatMessage(labels.noOptions)}
                                                className={classes.multipleSkills}
                                                getOptionSelected={(option, skill) => option.id === skill.id}
                                                getOptionLabel={(skill) => getLocalizedNameWithIntl(intl, { object: skill, value: "name" })}
                                                classes={{ option: classes.autoCompleteOption }}
                                                renderOption={(skill, { selected }) => (
                                                    <>
                                                        {" "}
                                                        <StyledCheckbox checked={selected} />
                                                        {getLocalizedNameWithIntl(intl, { object: skill, value: "name" })}
                                                    </>
                                                )}
                                                renderInput={(selected) => (
                                                    <TextField
                                                        {...selected}
                                                        label={intl.formatMessage(labels.skills)}
                                                        placeholder={intl.formatMessage(labels.addMore)}
                                                    />
                                                )}
                                            />
                                        );
                                    default:
                                        return null;
                                }
                            })()}
                        </Grid>
                    );
                })}
            </Grid>
            <div className={classes.btn}>
                <Button variant="text" onClick={props.onclose(false)}>
                    {intl.formatMessage(labels.cancel)}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handelSaveChanges}
                    disabled={
                        !(
                            formFields.filter((field) => field.isError === true).length === 0 &&
                            formFields.filter((field) => field.required === true && field.value === "").length === 0
                        )
                    }>
                    {props.buttonText}
                </Button>
            </div>

            <Modal
                show={props.error.body ? props.error.body : false}
                title={intl.formatMessage(labels.error)}
                children={getChildren(intl, props.error)}
                onClose={() => props.createTechnicianFailed("")}
            />
        </form>
    );
}

const messages = defineMessages({
    userNameAlreadyExists: {
        id: "labourer-edit-form.user-already-exists-message",
        defaultMessage: "The username you have entered is already in use.Please enter another username.",
        description: "username already exists error message",
    },
    invalidEmailId: {
        id: "labourer-edit-form.email-id-invalid-message",
        defaultMessage: "The email address you have entered is invalid or already in use.Please enter another email address.",
        description: "email already exists or invalid error message",
    },
});

function getChildren(intl, result) {
    if (!result || !result.statusCodeValue) {
        return "";
    } else if (result.statusCodeValue === 226) return intl.formatMessage(messages.userNameAlreadyExists);
    else if (result.statusCodeValue === 400) return intl.formatMessage(messages.invalidEmailId);

    return result.body;
}

export default connect(mapStateToProps, mapDispatchToProps)(LabourerEditForm);
